module.exports = __webpack_public_path__ + "static/media/10.933646b6.jpg";